<footer class="footer">
  <div class="footer__parralax">
    <div class="footer__parralax-secondplan"></div>
    <div class="footer__parralax-premierplan"></div>
  </div>
  <div class="footer-section">
    <div class="container">
      <div class="footer-cta footer-content pb-5">
        <div class="row first-row">
          <div class="col-xl-8 col-lg-8 mb-50">
            <div class="swiper mt-5">
              <div class="swiper-wrapper">
                <div class="swiper-slide">
                  <div class="p-1">
                    <div class="d-flex justify-content-center align-items-center w-100 gap-3">
                      <a href="https://apinovin.iranianasnaf.ir/parvaneh/e5247e63-8197-4320-9685-eeab0b36c20a/html"
                        rel="noopener" target="_blank"><img alt="پروانه کسب اتحادیه کشوری کسب و کارهای مجازی"
                          class="aligncenter wp-image-2098 size-thumbnail"
                          src="/images/etehadiekeshvaripng.parspng.com_.webp" loading="lazy" /></a>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="p-1">
                    <div class="d-flex justify-content-center align-items-center w-100 gap-3">
                      <a referrerpolicy='origin' target='_blank'
                        href='https://trustseal.enamad.ir/?id=431994&Code=OpwuFXuOJW5EGgfr3gwACLRt5BBntJWI'><img
                          referrerpolicy='origin'
                          src='https://trustseal.enamad.ir/logo.aspx?id=431994&Code=OpwuFXuOJW5EGgfr3gwACLRt5BBntJWI'
                          alt='نماد اعتماد الکترونیکی' style='cursor:pointer'
                          code='OpwuFXuOJW5EGgfr3gwACLRt5BBntJWI'></a>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="p-1">
                    <div class="d-flex justify-content-center align-items-center w-100 gap-3">
                      <!-- این‌ها نشان‌اند، نه لینک. قبلاً داخل <a href=""> بودند که هم برای
                           صفحه‌خوان لینکِ بی‌نام می‌ساخت و هم با کلیک صفحه را دوباره بار می‌کرد. -->
                      <img alt="شرکت تجارت الکترونیک پارسیان" class="size-full wp-image-2032 aligncenter"
                        loading="lazy" src="/images/images-1-1.webp" />
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="p-1">
                    <div (click)="showFullImage('/images/parvane_kasb1.jpg', $event)"
                      class="d-flex justify-content-center align-items-center w-100 gap-3">
                      <img alt="پروانه کسب اتحادیه طلا و جواهر" class="size-full wp-image-2032 aligncenter"
                        loading="lazy" src="/images/etehadie_tala.webp" />
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="p-1">
                    <div (click)="showFullImage('/images/faaliat.webp', $event)"
                      class="d-flex justify-content-center align-items-center w-100 gap-3">
                      <img alt="سازمان نظام صنفی رایانه‌ای کشور" class="size-full wp-image-2032 aligncenter"
                        loading="lazy" src="/images/nezam_senfi.webp" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-lg-4 mb-50">
            <div class="footer-widget">
              <div class="footer-logo">
                <img alt="logo" loading="lazy" src="/images/baazar.svg" width="80" height="48">
              </div>
              <div class="footer-text">
                <p>بازَر اولین اپلیکیشن خرید و فروش طلا به صورت آنلاین در ایران است که کاربران را قادر
                  می‌سازد با هر مبلغی (حتی یک صدم گرم) در بازار طلا سرمایه‌گذاری کنند</p>
              </div>
              <span class="d-block" style="color: #DBB879;cursor: pointer;" (click)="goToRules()">قوانین و مقررات</span>
            </div>
          </div>
        </div>
      </div>
      <div class="pt-5 pb-5">
        <div class="row">
          <div class="col-lg-6 mb-30">
            <div class="single-cta">
              <div class="cta-text">
                <h2 class="mb-3">آدرس ما</h2>
                <span class="d-block my-3" style="color: #DBB879;cursor: pointer;" (click)="goToContactUs()">لوکیشن دقیق
                  شرکت</span>
                <div class="footer-cta pb-3">
                  <span class="d-block" style="direction: rtl;" *ngIf="rules?.address"> {{ rules?.address }}</span>
                </div>
                <div class="mt-3">
                  <span class="text-center">
                    دفتر معاملات: کرج، چهارراه امام، خیابان شهید دکتر بهشتی، خیابان دکتر همایون، پلاک 25، طبقه همکف
                    شماره تماس : 02632284227
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 mb-30">
            <div class="row last-row">
              <div class="col-lg-6 col-md-6">
                <div class="single-cta">
                  <div class="cta-text">
                    <h2 class="mb-3"> تماس با ما </h2>
                    <a *ngFor="let num of supportNumbers" class="justify-content-end"
                      style="color: white;text-decoration:none;min-width: 44px;min-height: 44px;"
                      [href]="'tel:+' + num">{{ num }}</a>
                    <div class="mt-3">
                      <span class="d-block mt-2">پشتیبانی: شنبه تا چهارشنبه 9 الی 18</span>
                      <span class="d-block mt-2"> پنج شنبه 9 الی 14</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-md-6">
                <div class="single-cta">
                  <div class="cta-text">
                    <h2 class="mb-3">ایمیل پشتیبانی</h2>
                    <a href="mailto:info@baazar.ir" class="justify-content-center"
                      style="color: white;text-decoration:none">info&#64;baazar.ir</a>
                  </div>
                  <!-- <div class="cta-text mt-5">
                    <h4 class="mb-3">دانلود اپلیکیشن</h4>
                    <div class="d-flex gap-2 mt-3 justify-content-end">
                      <img (click)="openBazarLink()" alt="" loading="lazy" src="/images/download-from-bazar.webp" width="140">
                      <img (click)="openMayketLink()" alt="" loading="lazy" src="/images/download-from-myket.webp" width="140">
                    </div>
                  </div> -->
                  <div class="footer-social-icon mt-5">
                    <span>ما را در شبکه های اجتماعی دنبال کنید</span>
                    <div class="d-flex gap-3 justify-content-end">
                      <img (click)="openAparatLink()" alt="aparat" loading="lazy" src="/images/aparat.webp" width="26">
                      <img (click)="openBaleLink()" alt="bale" loading="lazy" src="/images/ic_bale.svg" width="26">
                      <img (click)="openTelegramLink()" alt="telegram" loading="lazy" src="/images/telegram.webp"
                        width="26">
                      <img (click)="openInstagramLink()" alt="instagram" loading="lazy" src="/images/instagram.webp"
                        width="26">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="copyright-area">
      <div class="container-fluid text-center" style="color: #909090;font-size: 14px;">
        تمامی حقوق مادی و معنوی برای این سایت محفوظ است
      </div>
    </div>
  </div>
  <button class="back-to-top" *ngIf="showButton" (click)="scrollToTop()" aria-label="بازگشت به بالا">
    ↑
  </button>
</footer>